import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    .enrique-layout {
      grid-template-rows:
        var(--top-padding-height)
        minmax(0, auto)
        minmax(0, auto)
        var(--bottom-padding-height)
        [last-line];
      width: 100%;
    }

    .block-header {
      grid-row: 2;
      grid-column: 2 / 8;
      margin-bottom: calc(20rem / var(--default-rem-px-count));
    }

    .images {
      grid-row: 3;
      grid-column: 2 / 8;
      display: flex;
      flex-direction: column;
      gap: calc(2 * var(--between-column-padding));
    }

    .image-wrapper {
      padding-bottom: calc(12rem / var(--default-rem-px-count));
      width: 100%;
      display: flex;
      flex-direction: column;
    }

    .img-container {
      max-height: calc((100vw - var(--default-rem-px-count)) * 2 / 3);
      width: calc(100vw - var(--default-rem-px-count));
      overflow: hidden;
    }

    .details {
      display: flex;
      flex-direction: column;
      gap: calc(14rem / var(--default-rem-px-count));
      padding-top: calc(10rem / var(--default-rem-px-count));
    }

    .description {
      text-wrap: pretty;
    }

    img {
      width: 100%;
      min-height: calc(150rem / var(--default-rem-px-count));
      object-fit: cover;
      aspect-ratio: 3 / 2;
    }

    .image-cta {
      display: none;
    }

    h3 {
      font-size: calc(16em / var(--default-rem-px-count));
      line-height: calc(18em / var(--default-rem-px-count));
      letter-spacing: -0.18px;
      font-weight: 400;
      padding: calc(4em / var(--default-rem-px-count)), 0;
    }

    cta-text {
      font-size: calc(16em / var(--default-rem-px-count));
      line-height: calc(18em / var(--default-rem-px-count));
      letter-spacing: -0.18px;
      font-weight: 500;
      margin: 0;
    }

    @media (min-width: 600px) {
      .block-header {
        grid-column: 2 / 14;
      }

      .images {
        grid-column: 2 / 14;
        flex-direction: row;
      }

      .img-container {
        min-height: unset;
        max-height: unset;
        width: 100%;
        overflow: unset;
      }

      img {
        min-height: unset;
        aspect-ratio: unset;
      }

      .first {
        grid-column: 2 / 8;
      }

      .second {
        grid-column: 8 / 14;
      }

      .image-cta {
        font-weight: 400;
        display: inherit;
      }

      h3 {
        font-size: calc(24em / var(--default-rem-px-count));
        line-height: calc(20em / var(--default-rem-px-count));
        letter-spacing: -0.72px;
        padding: calc(4em / var(--default-rem-px-count)), 0;
      }

      cta-text {
        font-size: calc(16em / var(--default-rem-px-count));
        line-height: calc(24em / var(--default-rem-px-count));
        letter-spacing: -0.24px;
        font-weight: 500;
        margin: 0;
      }
    }
  `,
];
